import { appConstants } from "../helpers/constants";

const initialState = {
  tags: [],
};

const tagReducer = (state = initialState, action) => {
  switch (action.type) {
    case appConstants.UPDATE_TAG_LIST: 
      return {
        ...state,
        tags: action.tags,
        isLoading: false,
      };
    case appConstants.REQUESTING: 
      return {
        ...state,
        isLoading: true,
      };      
    case appConstants.ERROR_OCCURED: 
      return {
        ...state,
        isLoading: false,
        error: action.error
      };      

    default:
      return state;
  }
};

export default tagReducer;
